// extracted by mini-css-extract-plugin
module.exports = {"container":"box-module--container--3cDbC","box":"box-module--box--2hjFK","link":"box-module--link--3pi0o"};